module.exports = __webpack_public_path__ + "img/reload.19ff6340.svg";